<template>
  <div class="home">
    <EbHeading level="h1" class="eb-page-heading">Déclarer un accueil en surnombre</EbHeading>
    
    <div class="eb-content-default">
      
      <form action="#" @submit.prevent="sendDeclaration">
        <EbInput label="À compter du (jj/mm/aaaa)" type="date" required v-model="dateDebut"></EbInput>
        
        <EbInput label="Nombre d’enfants de moins de 11 ans accueillis" helpText="Dont mes propres enfants ou autres enfants présents à mon domicile hors contrats d'accueil rémunérés, dans la limite maximum de 8 enfants de moins de 11 ans et 4 enfants de moins de 3 ans." v-model="accueilSurnombreExceptionnel.nombreEnfantsAccueillis" type="number" required></EbInput>
        
        <fieldset>
          <legend>Nombre maximal d'enfants simultanément présents au domicile</legend>
          <EbInput label="Nombre d’enfants de 0 à 3 ans" v-model="accueilSurnombreExceptionnel.nombreEnfants0Et3Ans" type="number" required></EbInput>
          <EbInput label="Nombre d’enfants de 3 à 11 ans" v-model="accueilSurnombreExceptionnel.nombreEnfants3Et11Ans" type="number" required></EbInput>
        </fieldset>
        
        <EbInput label="Nombre de jours d’accueil en surnombre depuis le 1er janvier" v-model="accueilSurnombreExceptionnel.nombreJoursAccueilSurnombreDepuis1Janvier" type="number" required></EbInput>
        
        <EbButton type="submit">Envoyer la déclaration</EbButton>
      </form>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'accueilDerogatoire',
  data() {
    return {
      accueilSurnombreExceptionnel: {
        nombreEnfants0Et3Ans: 0,
        nombreEnfants3Et11Ans: 0,
        nombreEnfantsAccueillis: 0,
        nombreJoursAccueilSurnombreDepuis1Janvier: 0
      },
      dateDebut: null
    }
  },
  methods: {
    sendDeclaration: async function() {
      await this.$http
      .post('assmat/enfants/nouvelAccueil/derogatoire', {
        accueilSurnombreExceptionnel: this.accueilSurnombreExceptionnel,
        dateDebut: this.dateDebut
      })
      .then(resp => {
        this.$router.push({name: 'mesAccueils', params: {status: 'create'}})
      })
      .catch(error => {
        this.errorOnSave = true
        this.bannerTimestamp = this.getTime()
      })
    },
  }
}
</script>

<style>
.eb-input input:not([type="radio"]):not([type="checkbox"]) {
  display: inline-block !important;
  margin-left: 1em;
}
</style>
